import { COMPANY } from 'features/Landing/content';

/*
 * The apex, with no trailing slash. This MUST be the host the site actually
 * serves from: Netlify 301s www -> apex, so every canonical, og:url and
 * sitemap entry built on the www form pointed at a redirect, and Search
 * Console filed the pages under "Page with redirect" instead of indexing them.
 */
export const SITE_URL = 'https://dreamsbuilt.co.nz';

/**
 * Share preview used by Facebook, LinkedIn and Twitter. It has to live in
 * public/ (a bundled asset gets a hashed name that no crawler can guess) and
 * stay a JPEG at 1200x630: several crawlers still ignore WebP.
 */
export const OG_IMAGE_PATH = '/og-image.jpg';

/**
 * LocalBusiness schema for the whole site, rendered once from the root route.
 * Page-specific schemas (Service, BreadcrumbList, FAQPage) live with their routes.
 */
export const localBusinessJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Dreams Built',
  image: `${SITE_URL}${OG_IMAGE_PATH}`,
  // Google wants a logo of at least 112px; the 32px favicon was below it.
  logo: `${SITE_URL}/android-chrome-192x192.png`,
  telephone: '+64 21 412 384',
  email: 'admin@dreamsbuilt.co.nz',
  url: SITE_URL,
  // Ties the site to its Google Business Profile and social pages as one business.
  sameAs: [
    COMPANY.googleProfileUrl,
    COMPANY.facebookUrl,
    COMPANY.linkedinUrl
  ],
  priceRange: '$$',
  description:
    'Dreams Built specialises in expert concrete foundations, driveways, patios, fencing and landscaping for residential and commercial projects across Waikato and Hamilton, New Zealand.',
  foundingDate: '2015',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '494 Pickering Road',
    addressLocality: 'Tamahere',
    addressRegion: 'Waikato',
    postalCode: '3800',
    addressCountry: 'NZ'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: -37.8136,
    longitude: 175.32
  },
  areaServed: [
    { '@type': 'City', name: 'Hamilton' },
    { '@type': 'City', name: 'Morrinsville' },
    { '@type': 'City', name: 'Cambridge' },
    { '@type': 'City', name: 'Te Awamutu' },
    { '@type': 'AdministrativeArea', name: 'Waikato' }
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Concrete & Construction Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Residential Foundations' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Commercial Foundations' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Concrete Driveways' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Patios' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Fencing' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Hard Landscaping' } }
    ]
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '07:00',
      closes: '17:00'
    }
  ]
} as const;
